import Task from './task'

export default class Job extends Task {
    static exportFields = ['id', 'name', 'parent{id name postalCode}', 'project{name}', 'company{name}', 'service{name}', 'stepName', 'stepType', 'reportedAt', 'description', 'isCompleted', 'isJobActive', 'statusCode', 'dueRequestDate', 'dueAfterDate', 'dueBeforeDate', 'createdAt', 'updatedAt'];
    static searchConfig = [
        {
            'icon': 'mdi-account-outline',
            'label': 'Uit te voeren door',
            'type': 'fixed',
            'settings': {
                'module': 'searchUsers',
                'fields': ['firstName', 'lastName', 'username'],
                'title': '{firstName} {lastName} ({username})',
                'options': {
                    enabled: true
                },
            },
            'filter': 'userId'
        },
        {
            'icon': 'mdi-account-outline',
            'label': 'Verantwoordelijke',
            'type': 'relation',
            'settings': {
                'module': 'searchUsers',
                'fields': ['firstName', 'lastName', 'username'],
                'title': '{firstName} {lastName} ({username})',
                'options': {
                    enabled: true
                },
                'table': 'tasks_responsible_users',
                'id': 'userId',
            },
            'filter': 'responsibleUsers'
        },
        {
            'icon': 'mdi-account-multiple-outline',
            'label': 'Team',
            'type': 'module',
            'settings': {
                'module': 'groups',
                'fields': ['name'],
                'title': '{name}',
            },
            'filter': 'responsibleGroupId'
        },
        {
            'icon': 'mdi-clipboard-outline',
            'label': 'Workflow',
            'type': 'module',
            'settings': {
                'module': 'taskTypes',
                'fields': ['name'],
                'title': '{name}',
            },
            'filter': 'taskTypeId'
        },
        {
            'icon': 'mdi-folder-open-outline',
            'label': 'Project',
            'type': 'module',
            'settings': {
                'module': 'projects',
                'fields': ['name', 'description'],
                'title': '{name} ({description})',
            },

            'filter': 'projectId'
        },
        {
            'icon': 'mdi-file-sign',
            'label': 'Dienst',
            'type': 'module',
            'settings': {
                'module': 'services',
                'fields': ['name'],
                'title': '{name}',
            },

            'filter': 'serviceId'
        },
        {
            'icon': 'mdi-office-building-outline',
            'label': 'Bedrijf',
            'type': 'module',
            'settings': {
                'module': 'companies',
                'fields': ['name', 'description'],
                'title': '{name} ({description})',
            },

            'filter': 'companyId'
        },
        {
            'icon': 'mdi-tag-outline',
            'label': 'Status',
            'type': 'options',
            'settings': {
                'options': (settings) => {
                    return settings.statusCodes;
                }
            },
            'filter': 'statusCode'
        },
    ];
}